import { AppBar, Hidden, IconButton, Toolbar } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import UserInfo from "../../components/UserInfo/UserInfo";
import useConfig from "../../hooks/useConfig";
import { useStore } from "../../hooks/useStore";
import { configFocusResetOn } from "../../redux/actions/configActions";
import { State, Type } from "../DrawerMain/DrawerMain";
import useStyles from "./NavBarStyles";

type NavbarProps = {
  menuState: State,
  menuAction: (type: Type) => void,
};

const NavBar = ({ menuState, menuAction }: NavbarProps) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [home, setHome] = useState(true);
  const { tabStore } = useStore();
  const { openDialogOnHold } = useConfig();
  const dispatch = useDispatch();
  const goBack = () => {
    if (tabStore.tabSelectIndex !== "-1") {
      openDialogOnHold({ goBack: true });
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    setHome(
      location.pathname === "/dashboard" ||
        location.pathname === "/dashboard/" ||
        location.pathname === "/dashboard/search"
    );
  }, [location]);

  const handleDrawerToggle = () => {
    if (menuState.open) menuAction(Type.CLOSE);
    else menuAction(Type.OPEN);
  };

  const onFocusMenu = (event: any) => {
    dispatch(configFocusResetOn());
  };

  const iconButtonBack = (
    <IconButton
      edge="start"
      color="primary"
      aria-label="menu"
      className={clsx(classes.menuButton, {})}
      onClick={goBack}
    >
      <ChevronLeftIcon />
    </IconButton>
  );

  const iconButtonMenu = (
    <IconButton
      edge="start"
      color="primary"
      aria-label="menu"
      className={clsx(classes.menuButton, {})}
      onClick={handleDrawerToggle}
      onFocus={onFocusMenu}
    >
      <MenuIcon />
    </IconButton>
  );

  const handleLeaveDrawer = () => {
    menuAction(Type.LEAVE_NAVBAR);
  };

  const handleEnterDrawer = () => {
    menuAction(Type.ON_NAVBAR);
  };

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}
      onMouseLeave={handleLeaveDrawer}
      onMouseEnter={handleEnterDrawer}
    >
      <Toolbar>
        <Hidden smDown>{iconButtonMenu}</Hidden>
        <Hidden mdUp>{home ? iconButtonMenu : iconButtonBack}</Hidden>
        <img src={logo} alt="logo" className={classes.logo} />
        <Hidden smDown>
          <div className={classes.user}>
            <UserInfo />
          </div>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};
export default NavBar;
